<template>
    <m-accordion-primary v-model="panel">
        <m-accordion-profile-content :items="forms"/>
    </m-accordion-primary>
</template>

<script>
    import MAccordionPrimary from "@modules/accordions/types/m-accordion-primary";
    import MFormProfileChangePassword from "@modules/forms/concrete/profile/m-form-profile-change-password";
    import MFormProfileEdit from "@modules/forms/concrete/profile/m-form-profile-edit";
    import MFormProfileMessages from "@modules/forms/concrete/profile/m-form-profile-messages";
    import MAccordionProfileContent from "@modules/accordions/includes/concrete/m-accordion-profile-content";

    export default {
        name: "m-accordion-profile",
        components: {
            MAccordionProfileContent,
            MAccordionPrimary
        },
        data: () => ({
            panel: []
        }),
        computed: {
            forms() {
                return [
                    {
                        title: this.$t('modules.accordions.m-accordion-profile.titles.edit-profile'),
                        name: 'm-form-profile-edit',
                        component: MFormProfileEdit
                    }, {
                        title: this.$t('modules.accordions.m-accordion-profile.titles.change-password'),
                        name: 'm-form-user-change-password',
                        component: MFormProfileChangePassword
                    }, /* {
                        title: this.$t('modules.accordions.m-accordion-profile.titles.messages'),
                        name: 'm-form-profile-messages',
                        component: MFormProfileMessages
                    } */
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    //
</style>
